module.exports = __webpack_public_path__ + "public/Icons/14Adminearnings.svg?6a3266bd";